<dl class="flag-list__summary">
    <div class="flag-list__summary-item">
        <dt>Customer</dt>
        <dd>{{ data.customerName }}</dd>
    </div>
    <div class="flag-list__summary-item">
        <dt>TripID</dt>
        <dd>{{ data.tripID }}</dd>
    </div>
    <div class="flag-list__summary-item">
        <dt>Type</dt>
        <dd>
            {{ data.serviceType }}<ng-container *ngIf="data.serviceSubType"> / {{ data.serviceSubType }}</ng-container>
        </dd>
    </div>
    <div class="flag-list__summary-item">
        <dt>Status</dt>
        <dd>{{ data.status }}</dd>
    </div>
</dl>

<div class="flag-list__toolbar">
    <div class="flag-list__tabs">
        <ds-tab-group
            class="flag-list__tab-group"
            theme="secondary-grey"
            [selectedTab]="selectedTabLabel"
            [tabs]="tabLabels"
            (selectedTabChange)="onTabChange($event)"
        ></ds-tab-group>
        <ng-container *ngIf="overdueCount">
            <app-ds-badge icon="schedule" size="md" theme="error" [label]="overdueCount + ' overdue'"></app-ds-badge>
        </ng-container>
    </div>

    <div class="flag-list__create">
        <ds-text size="sm" theme="tertiary" [text]="flagLimitLabel"></ds-text>
        <ds-button
            icon="add"
            label="Create Flag"
            size="sm"
            matTooltipPosition="left"
            [isDisabled]="isMaxFlagLimit"
            [matTooltip]="isMaxFlagLimit ? 'You have reached the maximum number of flags' : ''"
            (buttonClick)="createFlag.emit()"
        ></ds-button>
    </div>
</div>

<div class="flag-list__list">
    <ng-container *ngIf="activeTab === flagTypes.Active">
        <app-active-flags-table
            [flags]="activeFlags"
            (editFlag)="editFlag.emit($event)"
            (resolveFlag)="resolveFlag.emit($event)"
        ></app-active-flags-table>
    </ng-container>

    <ng-container *ngIf="activeTab === flagTypes.Resolved">
        <app-resolved-flags-table [flags]="resolvedFlags"></app-resolved-flags-table>
    </ng-container>
</div>
